package com.macrofocus.eflux.ui

import com.macrofocus.common.units.Quantity
import js.objects.unsafeJso
import org.molap.aggregates.cube.DistributiveStatistics
import org.molap.series.Series
import react.FC
import react.Props
import react.dom.svg.ReactSVG.path
import react.dom.svg.ReactSVG.svg
import web.cssom.px

external interface SparklineProps : Props {
    var series: Series<Any?, *>?
    var maximum: Number?
    var minimum: Number?
    var getWidth: Double
    var dateTime: Series<Any?, *>?
    var dateTimeStatistics: DistributiveStatistics?
    var statistics: DistributiveStatistics?
    var paletteType: PaletteType
    var displayDateTime: Long
}

val Sparkline = FC<SparklineProps> { props ->
    val series: Series<Any?, *>? = props.series
    val getWidth: Double = props.getWidth
    val dateTime: Series<Any?, *>? = props.dateTime
    val dateTimeStatistics: DistributiveStatistics? = props.dateTimeStatistics
    val statistics: DistributiveStatistics? = props.statistics
    val paletteType: PaletteType = props.paletteType
    val displayDateTime = props.displayDateTime

    val maximum = props.maximum
    val minimum = props.minimum

    svg {
        val width = getWidth // 4 is the margin left + right,
        val height = 100.0
        val strokeWidth = 2.0

        style = unsafeJso {
            minHeight = 0.px
            marginLeft = 20.px
            marginRight = 26.px
        }

//                                        this.width = width
        this.asDynamic().width = "100%"
        this.asDynamic().height = "100%"
//                this.asDynamic().minHeight = 0
//                this.height = height
        this.preserveAspectRatio = "none"

        val w = width - 0 // 12 for the elevation effect

        viewBox = "0 0 $width $height"

        if (series != null && statistics != null && dateTime != null && dateTimeStatistics != null) {
            if (statistics.mean != null) {
                var x1: Double? = null
                var y1: Double? = null

                val paths = sparklinePath(
                    series,
                    dateTime,
                    dateTimeStatistics,
                    w,
                    maximum,
                    minimum,
                    height,
                    strokeWidth,
                    x1,
                    y1,
                    displayDateTime
                )

                //                path.append("L ${w},$height ")


                if (!paths.first.isEmpty()) {
                    val path = paths.first
                    val stroke = "M " + path.toString()
                    val x = computeX(displayDateTime.toDouble(), dateTimeStatistics, w)
                    path.append("L $x,$height")
                    val fill = "M 0,$height L " + path.toString()
                    path {
                        d = fill
                        this.stroke = "none"
                        this.fill = if (paletteType == PaletteType.dark) "rgb(230, 230, 230, 0.4)" else "rgb(87, 87, 87, 0.4)"
                    }
                    path {
                        d = stroke
                        this.stroke = if (paletteType == PaletteType.dark) "white" else "black"
                        this.fill = "none"
                    }
                }
                if (!paths.second.isEmpty()) {
                    val path = paths.second
                    val stroke = "M " + path.toString()
                    val x = computeX(displayDateTime.toDouble(), dateTimeStatistics, w)
                    path.append("L $width,$height")
                    val fill = "M $x,$height L " + path.toString()
                    path {
                        d = fill
                        this.stroke = "none"
                        this.fill = if (paletteType == PaletteType.dark) "rgb(230, 230, 230, 0.2)" else "rgb(87, 87, 87, 0.2)"
                    }
                    path {
                        d = stroke
                        this.stroke = if (paletteType == PaletteType.dark) "darkgrey" else "lightgrey"
                        this.fill = "none"
                    }
                }
            }
        }
    }
}

private fun sparklinePath(
    series: Series<Any?, *>,
    dateTime: Series<Any?, *>,
    dateTimeStatistics: DistributiveStatistics,
    w: Double,
    maximum: Number?,
    minimum: Number?,
    height: Double,
    strokeWidth: Double,
    x1: Double?,
    y1: Double?,
    displayDateTime: Long
): Pair<StringBuilder, StringBuilder> {
    var x11 = x1
    var y11 = y1
    val before = StringBuilder()
    val after = StringBuilder()
    if(maximum != null && minimum != null) {
        for (row in series.keys()!!) {
            val t = (dateTime[row] as Long).toDouble()
            val o = series.get(row)
            val v = if (o is Quantity<*>) o.amount else o
            if (v is Number) {
                val x =
                    computeX(t, dateTimeStatistics, w)
                val range = maximum.toDouble() - minimum.toDouble()
                val h = height - strokeWidth
                val y =
                    if (range > 0.0) height - (((v.toDouble() - minimum.toDouble()) / range * h) + (strokeWidth / 2)) else 0.5 * height

                //                        if(linePoints.isEmpty()) {
                //                            linePoints.append("$x,$y")
                //                        } else {
                //                            linePoints.append(" $x,$y")
                //                        }

                if (x11 == null) {
                    x11 = x
                    y11 = y
                    if (t < displayDateTime)
                        before.append("$x,$y ")
                    else {
                        after.append("$x,$y ")
                    }
                } else {
                    //                            line {
                    //                                this.x1 = x1
                    //                                this.x2 = x
                    //                                this.y1 = y1
                    //                                this.y2 = y
                    //
                    //                                stroke = if (paletteType == PaletteType.dark)
                    //                                    if (t < displayDateTime) "white" else "darkgrey"
                    //                                else
                    //                                    if (t < displayDateTime) "black" else "lightgrey"
                    //
                    //                                this.strokeWidth = strokeWidth
                    //                                this.vectorEffect = "non-scaling-stroke"
                    //                            }

                    if (t < displayDateTime)
                        before.append("L $x,$y ")
                    else {
                        if (after.isEmpty()) {
                            after.append("$x,$y ")
                        } else {
                            after.append("L $x,$y ")
                        }
                    }

                    x11 = x
                    y11 = y
                }
            }
        }
    }
    return Pair(before, after)
}

private fun computeX(
    time: Double,
    dateTimeStatistics: DistributiveStatistics,
    width: Double
): Double {
    val x =
        (time - dateTimeStatistics.minimum!!.toDouble()) / (dateTimeStatistics.maximum!!.toDouble() - dateTimeStatistics.minimum!!.toDouble()) * width
    return x
}